<template>
    <div>
        <label
            v-if="label"
            :for="`select-${uid}`"
            v-text="label"
            class="label flex justify-between"
        />
        <select
            :id="`select-${uid}`"
            :name="`select-${uid}`"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.value)"
            :class="[
                errors && errors.length && 'border-red-300 text-red-900 placeholder-red-300',
                (!errors || !errors.length) && 'border border-slate-300',
            ]"
            class="bg-slate-100 w-full max-w-full rounded-md border border-slate-300 py-2 text-left text-base font-medium leading-5 text-slate-700 shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 sm:text-sm"
        >
            <option v-if="placeholder" disabled v-text="placeholder"/>
            <option v-for="option in options" :value="option.value" v-text="option.text"/>
        </select>
        <p v-if="errors && errors.length" class="mt-1 text-sm text-red-600">
            <span v-for="error in errors" :key="error" v-text="error" class="block"/>
        </p>
    </div>
</template>

<script setup>
import { v4 as uuidv4 } from 'uuid';

const uid = uuidv4()
const props = defineProps({
    modelValue: [String, Number],
    options: Array,
    label: String,
    placeholder: String,
    type: {
        type: String,
        default: 'text'
    },
    errors: {
        required: false,
        type: Array
    },
})
</script>
